import { Http } from '../../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.hits_pacs = {
      ...state.admin.reportes.facturacion.hits_pacs,
      data: {
        ...state.admin.reportes.facturacion.hits_pacs.data,
        ...data,
      },
    };
  });
};

const paginate = async (store, meta) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.hits_clientes = {
      ...state.admin.reportes.facturacion.hits_clientes,
      busy: true,
      filters: {
        ...state.admin.reportes.facturacion.hits_clientes.filters,
        ...meta,
      },
      pagination: {
        ...state.admin.reportes.facturacion.hits_clientes.pagination,
        limit: meta?.limit ?? 25,
      },
    };
  });

  try {
    const { pagination } = store.state.admin.reportes.facturacion.hits_pacs;
    const params = {
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get(`/app/admin/reportes/hits-por-pac`, { params });

    store.setState((state) => {
      state.admin.reportes.facturacion.hits_pacs = {
        ...state.admin.reportes.facturacion.hits_pacs,
        busy: false,
        data: response.data,
        pagination: {
          ...state.admin.reportes.facturacion.hits_pacs.pagination,
          ...response.meta.pagination,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.reportes.facturacion.hits_clientes.busy = false;
      state.admin.reportes.facturacion.hits_clientes.error = error.data || error;
    });
  }
};

const updateFilters = (store, filters) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.hits_pacs.filters = {
      ...state.admin.reportes.facturacion.hits_pacs.filters,
      ...filters,
    };
  });
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.reportes.facturacion.hits_pacs = {
      ...initialState,
    };
  });
};

const ReporteFacturacionHitsPorPacListStore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
    updateFilters,
  },
};

export default ReporteFacturacionHitsPorPacListStore;
